// @flow

import axios from 'axios';

import cache from './../Core/NetworkCache';

import type {Cache} from './../Core/NetworkCache';
import type {Airing, Episode, Show, Channel, Schedule} from './Objects';

export type AiringIdArray = Array<number>;
export type ChannelIdArray = Array<Channel>;

export type AiringAPIResponse = {|
  entities: {|
    show: {| [number]: Show |},
    episode: {| [number]: Episode |},
    airing: {| [number]: Airing |},
  |},
  result: AiringIdArray
|};

export type ScheduleAPIResponse = {|
  entities: {|
    show: {| [number]: Show |},
    episode: {| [number]: Episode |},
    airing: {| [number]: Airing |},
    channel: {| [Channel]: Schedule |}
  |},
  result: ChannelIdArray
|};

export type Client = {|
  getSchedule: (
    year: number,
    month: number,
    day: number,
    interval: number,
    channel?: Channel
  ) => Promise<ScheduleAPIResponse>,
  search: (
    term: string,
    start?: number,
    end?: number
  ) => Promise<AiringAPIResponse>
|};

export default function client(
  endpoint: string,
  httpClient?: Object
): Client {
  const TARGET_SIZE = 15;
  const CAP = 30;

  let innerClient = httpClient || axios;

  if (endpoint[endpoint.length - 1] === '/') {
    endpoint = endpoint.slice(0, endpoint.length - 1);
  }

  // Cache of non full day schedule requests
  let airingCache: Cache<AiringAPIResponse> = cache(TARGET_SIZE, CAP, innerClient);

  // Cache of full day schedule requests
  let scheduleCache: Cache<ScheduleAPIResponse> = cache(TARGET_SIZE, CAP, innerClient);

  return {
    getSchedule: function(
      year: number,
      month: number,
      day: number,
      interval: number,
      channel?: Channel
    ): Promise<ScheduleAPIResponse> {
      let url = `${endpoint}/schedule/${year}/${month}/${day}/${interval}`;

      if (channel) {
        url = `${url}/${channel}`;
      }

      return scheduleCache.get(url);
    },
    search(term: string, start?: number, end?: number): Promise<AiringAPIResponse> {
      let url = `${endpoint}/search/${term}/`;
      let qs = [];

      if (start != null) {
        qs.push(`start=${start}`);
      }

      if (end != null) {
        qs.push(`end=${end}`);
      }

      return airingCache.get([url, qs.join('&')].join('?'));
    }
  };
}